<template>
    <v-layout pa-0 ma-0 row justify-space-between v-if="group" style="height: 28px">
        <v-flex xs6 class="d-inline-flex align-center">
            <div v-if="showLocation" class="location-row text-left ma-0"> {{group.location}} </div>
        </v-flex>
        <v-flex xs6 class="d-inline-flex justify-end align-center">
<!--            <div v-if="edit"  class="edit-btn ml-2" @click="openEditGroup">-->
<!--                <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex"/>-->
<!--            </div>-->
            <div v-if="edit" class="edit-btn ml-2" @click="openDeleteGroup">
                <v-img :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
            </div>
        </v-flex>
        <ModalDeleteConfirm
            v-model="deleteGroup"
            :url="`/scenarios/hotel-admin/scenario-group/${group.uid}/`"
            :close="closeDeleteGroup"
        >
            <template #deleteTitle>
                Вы действительно хотите <br> удалить группу сценариев {{group.name}}?
            </template>
        </ModalDeleteConfirm>
    </v-layout>
</template>

<script>
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";

export default {
    name: "ScenarioGroupStatus",
    components: {ModalDeleteConfirm},
    props: {
        group: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modalDelete: false,
            deleteGroup: false,
        };
    },
    methods: {
        openEditGroup() {
            // this.$router.push({
            //     name: "scenariopage",
            //     query: {
            //         scenario: this.scenarioData.uid
            //     },
            //     params: {
            //         id: this.room
            //     },
            // });
        },
        openDeleteGroup() {
            this.deleteGroup = true;
        },
        closeDeleteGroup() {
            this.deleteGroup = false;
        },
    },
}
</script>